export default "__VITE_ASSET__BNK_6nWj__"